const defaultSwipers = document.querySelectorAll(".featured-swiper--default");
const teacherSwipers = document.querySelectorAll(".featured-swiper--teachers");

const checkSlidesLength = (swiperInstance) => {
  let swiperActive = false;

  const slides = swiperInstance.querySelectorAll(".swiper-slide");
  if (slides.length > 2) {
    [].forEach.call(slides, (slide) => {
      slide.classList.add("swiper-slide-count-3");
    });
  }

  if (slides.length > 1 && window.innerWidth < 1025) {
    swiperActive = true;
  }

  if (slides.length > 3 && window.innerWidth > 1025) {
    swiperActive = true;
  }

  return swiperActive;
};

const removeEmptySlides = (swiperInstance) => {
  const slides = swiperInstance.querySelectorAll(".swiper-slide");
  [].forEach.call(slides, (slide) => {
    if (!slide.children.length > 0) {
      slide.parentNode.removeChild(slide);
    }
  });
};

if (defaultSwipers.length) {
  [].forEach.call(defaultSwipers, (swiperInstance) => {
    removeEmptySlides(swiperInstance);
    checkSlidesLength(swiperInstance);

    const featuredArticleSwipers = new Swiper(swiperInstance, {
      slidesPerView: "auto",
      watchOverflow: true,
    });
  });
}

if (teacherSwipers.length) {
  [].forEach.call(teacherSwipers, (swiperInstance) => {
    removeEmptySlides(swiperInstance);
    if (checkSlidesLength(swiperInstance)) {
      swiperInstance.parentElement
        .querySelector(".teacher-carousel-next")
        .classList.add("swiper-button--visible");
      swiperInstance.parentElement
        .querySelector(".teacher-carousel-prev")
        .classList.add("swiper-button--visible");

      const featuredTeachersSwipers = new Swiper(swiperInstance, {
        loop: false,
        slidesPerView: "auto",
        watchOverflow: true,
        navigation: {
          nextEl: swiperInstance.parentElement.querySelector(
            ".teacher-carousel-next"
          ),
          prevEl: swiperInstance.parentElement.querySelector(
            ".teacher-carousel-prev"
          ),
        },
      });
    }
  });
}
